export default "__VITE_ASSET__CRSTbt6S__"